import React from "react";
import { ConnectedProps } from "react-redux";

import AddEditForm from "../AddEditForm";
import connector from "./Container";

const AddInsurance = ({ actions }: ConnectedProps<typeof connector>) => {
  return <AddEditForm isAdd={true} actions={actions} />;
};

export default AddInsurance;
